import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button
} from "@mui/material"


const ProjectSendToGas = ({ rowData, mainProps, setErrorMessage }) => {



  return (
    <Box>
      <Button
        variant="contained"
        color="primary"
        size="small"
        style={{}}
        onClick={async () => {
            const { onSendGasProjectToGas } = mainProps
            if(window.confirm("از ارسال پرونده به شرکت گاز اطمینان دارید؟")){
                await onSendGasProjectToGas(rowData.row.fileNumber)
            }
           
        }}
        disabled={!rowData.row.isOk}
      >{rowData.row.solarDateSendToCoGas ?`تاریخ ارسال: ${rowData.row.solarDateSendToCoGas}` : 'ارسال به شرکت گاز'}
        
      </Button>
    </Box>
  )
}

export default ProjectSendToGas
